var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-input-date',_vm._g(_vm._b({attrs:{"config":_vm.config}},'iv-input-date',{ ..._vm.$attrs, ..._vm.$props, value: _vm.innateValue },false),{
        ..._vm.$listeners,
        'update:value': ($event) => (_vm.innateValue = $event),
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }